import { Language } from '@/types';
import { ApiDefinition, Feature } from '../types/api-definitions';
import { getLocalizedContent, getLocalizedFeatureContent } from '../utils/apiUtils';
import { useTranslation } from 'react-i18next';

export const useLocalizedContent = (apiDefinition: ApiDefinition) => {
  const { i18n } = useTranslation();
  return getLocalizedContent(apiDefinition, i18n.language as Language);
};

export const useLocalizedFeatures = (apiDefinition: ApiDefinition | null): Feature[] => {
  const { i18n } = useTranslation();
  if (!apiDefinition) {
    return [];
  }
  return getLocalizedFeatureContent(apiDefinition, i18n.language as Language) || [];
};
